export const ROLE_CANDIDATE = 'candidate';
export const ROLE_CANDIDATE_EPG = 'candidate_epg';
export const TIME_INACTIVE = 600;
export const URL_OFFICE_ADMISSION = 'https://admision.zendesk.com/hc/es/requests/new';
export const URL_RESULTS_ADMISSION = 'https://resultadosadmision.utp.edu.pe/auth/login';

export const FROM_START_EXAMEN = 'FROM_START_EXAM';
export const FROM_SUMMARY_EXAM = 'FROM_SUMMARY_EXAM';
export const FROM_LOAD_QUIZZES = 'FROM_LOAD_QUIZZES';
export const FROM_RESPONSE_EXAM = 'FROM_RESPONSE_EXAM';

export const URL_DOMAIN_EPG = process.env.REACT_APP_DOMAIN_EPG || 'postgradoepg-admission-dev.utpxpedition.com';
export const URL_DOMAIN_PREG = process.env.REACT_APP_DOMAIN_CLASS || 'admission-dev.utpxpedition.com';